export const statusFilterEN = {
  title: 'Status',
  employeeStatus: 'Employee Status',
  value: ['Active', 'Inactive'],
} as const;
